import {JetView} from "webix-jet"; // Importing JetView from webix-jet
import {devConfig} from "config/config"; // Importing development configuration

/**
 * Class representing the casino report view.
 * @extends JetView
 */
export default class tableCasinoReportView extends JetView {
    /**
     * Configures the UI components of the view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService("locale")._; // Localization service
        var vthis = this; // Reference to the current instance
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date formatting function

        /**
         * Formats a percentage value.
         * @param {number} value - The value to format.
         * @returns {string} The formatted percentage string.
         */
        function percentFormat(value) {
            return webix.i18n.numberFormat(value) + "%"; // Formatting as percentage
        }

        /**
         * Formats a monetary value.
         * @param {number} value - The value to format.
         * @returns {string} The formatted monetary string.
         */
        function penFormat(value) {
            return "$" + webix.i18n.numberFormat(value); // Formatting as currency
        }

        // Extending the summTreeColumn filter for custom behavior
        webix.ui.datafilter.summTreeColumn = webix.extend({
            refresh: function (master, node, value) {
                var result = 0; // Variable to hold the sum result
                var resultFormat = 0; // Variable for formatted result
                master.data.each(function (obj) {
                    if (obj.$level == 1) {
                        result += obj[value.columnId]; // Summing values based on column ID
                    }
                });
                // Formatting the result based on the column ID
                if (value.columnId === 'CantidadTickets') {
                    resultFormat = webix.i18n.intFormat(result);
                } else {
                    if (value.columnId === 'Profitness') {
                        resultFormat = webix.i18n.numberFormat(result) + "%";
                    } else {
                        resultFormat = webix.i18n.priceFormat(result);
                    }
                }
                node.firstChild.innerHTML = resultFormat; // Updating the node with the formatted result
            }
        }, webix.ui.datafilter.summColumn);

        return {
            rows: [
                {
                    cols: [
                        {
                            type: "wide",
                            view: "datatable", id: "datatable", // Main data table
                            css: "webix_header_border webix_data_border webix_footer_border", // CSS classes for styling
                            select: true, // Enable row selection
                            height: 0, // Initial height
                            columns: [
                                {id: "User", header: _("ID de Usuario"), width: 100, sort: "int"}, // User ID column
                                {id: "UserId", header: _("ID de Casino Usuario"), width: 150, sort: "text"}, // Casino User ID column
                                {id: "ProviderName", header: _("Proveedor"), width: 150, sort: "text"}, // Provider column
                                {id: "SubproviderName", header: _("Subproveedor"), width: 150, sort: "int"}, // Subprovider column
                                {id: "IdSession", header: _("ID de Sesión"), width: 150, sort: "int"}, // Session ID column
                                {id: "Game", header: _("Juego"), width: 150, sort: "int"}, // Game column
                                {id: "AmountBet", header: _("Valor Apostado"), format: penFormat, width: 200, sort: "int"}, // Bet amount column
                                {id: "AmountAward", header: _("Premio"), format: penFormat, width: 150, sort: "int"}, // Award amount column
                                {id: "GGR", header: _("GGR"), format: penFormat, width: 150, sort: "int"}, // Gross Gaming Revenue column
                                {id: "Rake", header: _("Rake"), format: penFormat, width: 150, sort: "int"}, // Rake column
                                {id: "TournamentInscription", format: penFormat, header: _("Inscripción a torneo"), width: 150, sort: "int"}, // Tournament inscription column
                                {id: "GGRPercentage", header: _("% Ggr"), width: 150, sort: "int"}, // GGR percentage column
                            ],
                            on: {
                                onBeforeLoad: function () {
                                    // Show loading overlay before data load
                                    this.showOverlay("<div id='contenedor'; class='container-preload'><div style='position: fixed; top: calc(50% - 57px);left: calc(50% - 60px);width: 120px;' class='progress'><div class='icon-preload girando'></div><div class='load-text'>Loading... </div></div></div>");
                                },
                                onAfterLoad: function () {
                                    this.hideOverlay(); // Hide loading overlay after data load
                                }
                            },
                            ready: function () {
                                // Show no data overlay if no records are found
                                if (!this.count()) {
                                    webix.extend(this, webix.OverlayBox);
                                    this.showOverlay("<div class='no-data' style='margin:75px; font-size:18px;'>" + _('No hay datos') + "</div>");
                                }
                            },
                            tooltip: true, // Enable tooltips
                            math: true, // Enable math operations
                            loadahead: 0, // Load ahead configuration
                            datafetch: devConfig.getDefaultDataFetch(), // Default data fetch configuration
                            pager: "pagerA" // Pager ID for pagination
                        },
                        {
                            type: "wide",
                            scrollY: true, // Enable vertical scrolling
                            height: 0, // Initial height
                            view: "treetable", id: "datatable2", // Tree table for hierarchical data
                            css: "webix_header_border webix_data_border webix_footer_border", // CSS classes for styling
                            columns: [
                                {
                                    id: "ProviderName", header: _("Proveedor"), // Provider name column
                                    fillspace: 0, minWidth: 0, width: 200,
                                    sort: "text", format: dateFormat, template: function (obj, common) {
                                        // Custom template for displaying provider names
                                        if (obj.$group) return common.treetable(obj, common) + obj.value;
                                        return obj.ProviderName;
                                    }
                                },
                                {id: "SubproviderName", header: _("Subproveedor"), width: 150, sort: "int"}, // Subprovider column
                                {id: "User", header: _("ID de Usuario"), width: 100, sort: "int"}, // User ID column
                                {id: "UserId", header: _("ID de Casino Usuario"), width: 150, sort: "int"}, // Casino User ID column
                                {id: "IdSession", header: _("ID de Sesión"), width: 150, sort: "int"}, // Session ID column
                                {id: "GameType", header: _("Juego"), width: 150, sort: "int"}, // Game type column
                                {id: "TotalAmountBet", header: _("Valor Apostado Total"), format: penFormat, width: 200, sort: "int"}, // Total bet amount column
                                {id: "TotalAmountAward", header: _("Premio Total"), format: penFormat, width: 150, sort: "int"}, // Total award amount column
                                {id: "GGR", header: _("Ggr"), format: penFormat, width: 150, sort: "int"}, // Gross Gaming Revenue column
                                {id: "Rake", header: _("Rake"), format: penFormat, width: 150, sort: "int"}, // Rake column
                                {id: "TotalTournamentInscription", format: penFormat, header: _("Inscripción a Torneos total"), width: 200, sort: "int"}, // Total tournament inscription column
                                {id: "GGRPercentage", header: _("% Ggr"), format: percentFormat, width: 150, sort: "int"}, // GGR percentage column
                            ],
                            on: {
                                onBeforeLoad: function () {
                                    // Show loading overlay before data load
                                    this.showOverlay("<div id='contenedor'; class='container-preload'><div style='position: fixed; top: calc(50% - 57px);left: calc(50% - 60px);width: 120px;' class='progress'><div class='icon-preload girando'></div><div class='load-text'>Loading... </div></div></div>");
                                },
                                onAfterLoad: function () {
                                    this.hideOverlay(); // Hide loading overlay after data load
                                }
                            },
                            ready: function () {
                                // Show no data overlay if no records are found
                                if (!this.count()) {
                                    webix.extend(this, webix.OverlayBox);
                                    this.showOverlay("<div class='no-data' style='margin:75px; font-size:18px;'>" + _('No hay datos') + "</div>");
                                }
                            },
                            tooltip: true, // Enable tooltips
                            math: true, // Enable math operations
                            loadahead: devConfig.getDefaultDataFetch(), // Default data fetch configuration
                            pager: {
                                size: 10000, // Page size for pagination
                                id: "pagerr" // Pager ID
                            }
                        },
                        {
                            type: "wide",
                            view: "datatable", id: "datatable3", // Another data table
                            css: "webix_header_border webix_data_border webix_footer_border", // CSS classes for styling
                            select: true, // Enable row selection
                            height: 0, // Initial height
                            columns: [
                                {id: "User", header: _("ID de Usuario"), width: 100, sort: "int"}, // User ID column
                                {id: "UserId", header: _("ID de Casino Usuario"), width: 150, sort: "text"}, // Casino User ID column
                                {id: "ProviderName", header: _("Proveedor"), width: 150, sort: "text"}, // Provider column
                                {id: "SubproviderName", header: _("Subproveedor"), width: 150, sort: "int"}, // Subprovider column
                                {id: "TotalAmountBet", header: _("Valor Apostado Total"), format: penFormat, width: 200, sort: "int"}, // Total bet amount column
                                {id: "TotalAmountAward", header: _("Premio Total"), format: penFormat, width: 150, sort: "int"}, // Total award amount column
                                {id: "GGR", header: _("GGR"), format: penFormat, width: 150, sort: "int"}, // Gross Gaming Revenue column
                                {id: "Rake", header: _("Rake"), format: penFormat, width: 150, sort: "int"}, // Rake column
                                {id: "TotalTournamentInscription", format: penFormat, header: _("Inscripción a Torneos Total"), width: 150, sort: "int"}, // Total tournament inscription column
                                {id: "GGRPercentage", header: _("% Ggr"), width: 150, sort: "int"}, // GGR percentage column
                            ],
                            on: {
                                onBeforeLoad: function () {
                                    // Show loading overlay before data load
                                    this.showOverlay("<div id='contenedor'; class='container-preload'><div style='position: fixed; top: calc(50% - 57px);left: calc(50% - 60px);width: 120px;' class='progress'><div class='icon-preload girando'></div><div class='load-text'>Loading... </div></div></div>");
                                },
                                onAfterLoad: function () {
                                    this.hideOverlay(); // Hide loading overlay after data load
                                }
                            },
                            ready: function () {
                                // Show no data overlay if no records are found
                                if (!this.count()) {
                                    webix.extend(this, webix.OverlayBox);
                                    this.showOverlay("<div class='no-data' style='margin:75px; font-size:18px;'>" + _('No hay datos') + "</div>");
                                }
                            },
                            tooltip: true, // Enable tooltips
                            math: true, // Enable math operations
                            loadahead: 0, // Load ahead configuration
                            datafetch: devConfig.getDefaultDataFetch(), // Default data fetch configuration
                            pager: "pagerr" // Pager ID for pagination
                        }
                    ]
                }
            ]
        };
    }

    /**
     * Initializes the view and sets up event handlers.
     * @param {Object} grid - The main data grid.
     */
    init(grid) {
        const _ = this.app.getService("locale")._; // Localization service
        grid = $$('datatable'); // Reference to the first data table
        var grid2 = $$('datatable2'); // Reference to the second data table
        var grid3 = $$('datatable3'); // Reference to the third data table
        var url = devConfig.geturlApi() + "null/Report/GetPokerReport"; // API endpoint for poker report
        var url2 = devConfig.geturlApi() + "null/Report/GetPokerReport"; // Duplicate API endpoint (possibly for future use)
        var flag = false; // Flag for export operations
        var vthis = this; // Reference to the current instance
        grid.hide(); // Hide the first grid initially
        grid3.hide(); // Hide the third grid initially
        $$("toolbar1").hide(); // Hide the first toolbar initially

        // Event handler for after loading data into the second grid
        grid2.attachEvent("onAfterLoad", function () {
            $$("datatable2").data.group({
                by: "ProviderName", // Grouping by provider name
                map: {
                    ProviderName: ["ProviderName"],
                    Subproveedor: ["Subproveedor"],
                    User: ["User"],
                    UserId: ["UserId"],
                    IdSession: ["IdSession"],
                    TotalAmountBet: ["TotalAmountBet", "sum"], // Summing total bet amounts
                    TotalAmountAward: ["TotalAmountAward", "sum"], // Summing total award amounts
                    GGR: ["GGR", "sum"], // Summing GGR
                    Rake: ["Rake", "sum"], // Summing rake
                    TotalTournamentInscription: ["TotalTournamentInscription", "sum"], // Summing total tournament inscriptions
                    GGRPercentage: ["GGRPercentage", "sum"], // Summing GGR percentage
                }
            });
        });

        var filter = ""; // Variable to hold filter parameters
        // Event handler for filtering data based on user input
        this.on(this.app, "casinoReport:filter", filterData => {
            var object = Object.entries(filterData); // Convert filter data to entries
            var string1 = ""; // Query string for date filters
            var string2 = ""; // Query string for sorting
            var providergroup = 0; // Variable to determine provider group

            // Loop through filter data to construct query strings
            for (var i = 0; i < object.length; i++) {
                if (object[i][0] == "Type") {
                    if (object[i][1] == 0) {
                        // No action for type 0
                    } else if (object[i][1] == 1) {
                        providergroup = 1; // Set provider group to 1
                    } else if (object[i][1] == 2) {
                        providergroup = 2; // Set provider group to 2
                    }
                }
                if (object[i][0] == "Sort" && providergroup == 0) {
                    // Construct sorting query string
                    if (object[i][1] == '1') {
                        string2 = string2 + '&sort[Date]=';
                    } else {
                        if (object[i][1] == '2') {
                            string2 = string2 + '&sort[Username]=';
                        } else {
                            if (object[i][1] == '3') {
                                string2 = string2 + '&sort[Stakes]=';
                            } else {
                                if (object[i][1] == '4') {
                                    string2 = string2 + '&sort[Winnings]=';
                                }
                            }
                        }
                    }
                }
                if (object[i][0] == "Dir" && providergroup == 0) {
                    // Construct sorting direction query string
                    if (object[i][1] == '0') {
                        string2 = string2 + 'asc'; // Ascending order
                    } else {
                        if (object[i][1] == '1') {
                            string2 = string2 + 'desc'; // Descending order
                        }
                    }
                }
                if ((typeof object[i][1] !== "object") && (object[i][1] !== "")) {
                    // Construct date filter query string
                    if (object[i][0] == "Datepicker") {
                        var date = object[i][1].split(" - "); // Split date range
                        console.log(date);
                        string1 = string1 + '&dateFrom=' + date[0]; // Start date
                        string1 = string1 + '&dateTo=' + date[1]; // End date
                    } else {
                        if (object[i][0] != "Sort" && object[i][0] != "Dir" && object[i][0] != "Date") {
                            string1 = string1 + '&' + object[i][0] + '=' + object[i][1]; // Other filters
                        } else {
                            if (object[i][0] == "Date") {
                                var date = object[i][1].replace(" 00:00:00", ""); // Format date
                                string1 = string1 + '&dateFrom=' + date; // Start date
                                string1 = string1 + '&dateTo=' + date; // End date
                            }
                        }
                    }
                } else {
                    if ((typeof object[i][1] === "object")) {
                        var object2 = Object.entries(object[i][1]); // Convert nested object to entries
                        for (var j = 0; j < object2.length; j++) {
                            if (object2[j][1] !== null) {
                                if (object2[j][0] === "start") {
                                    var d = new Date(object2[j][1]); // Start date
                                    var dateFrom = "dateFrom=" + ((d.getFullYear())) + "-" + ("00" + (d.getMonth() + 1)).slice(-2) + "-" + ("00" + d.getDate()).slice(-2) + " " + ("00" + d.getHours()).slice(-2) + ":" + ("00" + d.getMinutes()).slice(-2) + ":" + ("00" + d.getSeconds()).slice(-2);
                                    string1 = string1 + '&' + dateFrom; // Add start date to query
                                } else {
                                    if (object2[j][0] === "end") {
                                        var d = new Date(object2[j][1]); // End date
                                        var dateTo = "dateTo=" + ((d.getFullYear())) + "-" + ("00" + (d.getMonth() + 1)).slice(-2) + "-" + ("00" + d.getDate()).slice(-2) + " " + ("00" + d.getHours()).slice(-2) + ":" + ("00" + d.getMinutes()).slice(-2) + ":" + ("00" + d.getSeconds()).slice(-2);
                                        string1 = string1 + '&' + dateTo; // Add end date to query
                                    }
                                }
                            }
                        }
                    }
                }
            }

            // Load data based on provider group
            if (providergroup == 0) {
                grid.show(); // Show the first grid
                grid2.hide(); // Hide the second grid
                grid3.hide(); // Hide the third grid
                grid.clearAll(); // Clear previous data
                grid.load(url + '?start=0&count=' + grid.data.$pagesize + string1 + string2).then(function (data) {
                    data = data.json(); // Parse JSON data
                    var columnsGrid = [];
                    grid.config.columns.forEach((item) => {
                        columnsGrid.push(item.id); // Collect column IDs
                    });
                    var difference = columnsGrid.filter(x => Object.keys(data.data[0]).indexOf(x) === -1); // Check for missing columns
                    if (difference.length > 0) {
                        difference.forEach((id) => {
                            if (id != 'detailTittle') {
                                grid.hideColumn(id); // Hide missing columns
                            }
                        });
                        grid.refreshColumns(); // Refresh column visibility
                    }
                });
                $$("toolbar1").show(); // Show the first toolbar
                $$("toolbar2").hide(); // Hide the second toolbar
            } else if (providergroup == 1) {
                grid2.show(); // Show the second grid
                grid3.hide(); // Hide the third grid
                grid.hide(); // Hide the first grid
                grid2.clearAll(); // Clear previous data
                console.log(grid2.data);
                grid2.load(url + '?start=0&count=' + grid2.data.$pagesize + string1 + string2).then(function (data) {
                    data = data.json(); // Parse JSON data
                    var columnsGrid = [];
                    grid2.config.columns.forEach((item) => {
                        console.log(item);
                        columnsGrid.push(item.ProviderId); // Collect column IDs
                    });
                    var difference = columnsGrid.filter(x => Object.keys(data.data[0]).indexOf(x) === -1); // Check for missing columns
                    if (difference.length > 0) {
                        difference.forEach((id) => {
                            grid2.hideColumn(id); // Hide missing columns
                        });
                        grid2.refreshColumns(); // Refresh column visibility
                    }
                });
                grid2.adjust(); // Adjust grid layout
                $$("toolbar2").show(); // Show the second toolbar
                $$("toolbar1").hide(); // Hide the first toolbar
            } else if (providergroup == 2) {
                grid3.show(); // Show the third grid
                grid2.hide(); // Hide the second grid
                grid.hide(); // Hide the first grid
                grid3.clearAll(); // Clear previous data
                grid3.load(url + '?start=0&count=' + grid3.data.$pagesize + string1 + string2).then(function (data) {
                    data = data.json(); // Parse JSON data
                    var columnsGrid = [];
                    grid3.config.columns.forEach((item) => {
                        columnsGrid.push(item.id); // Collect column IDs
                    });
                    var difference = columnsGrid.filter(x => Object.keys(data.data[0]).indexOf(x) === -1); // Check for missing columns
                    if (difference.length > 0) {
                        difference.forEach((id) => {
                            if (id != 'detailTittle') {
                                grid3.hideColumn(id); // Hide missing columns
                            }
                        });
                        grid3.refreshColumns(); // Refresh column visibility
                    }
                });
                $$("toolbar1").show(); // Show the first toolbar
                $$("toolbar2").hide(); // Hide the second toolbar
            }
            filter = string1 + string2; // Update filter variable
            $$("filterPopup").hide(); // Hide filter popup
        });

        // Event handler for sorting data in the first grid
        grid.attachEvent("onAfterSort", function (by, dir, as) {
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + filter + '&sort[' + by + ']=' + dir); // Load sorted data
        });

        // Event handler for selecting a player
        this.on(this.app, "player:select", id => {
            grid.load(grid.data.url + '?start=0&count=' + grid.data.$pagesize + '&PlayerId=' + id); // Load data for selected player
        });

        // Event handler for exporting filtered data
        this.on(this.app, "export:filter", filterData => {
            flag = true; // Set flag for export
            var firstfirst;
            if (filterData.first == 0) {
                firstfirst = filterData.first + 1; // Adjust first index for export
            } else {
                firstfirst = filterData.first; // Keep first index
            }
            grid.load(url + '?start=' + (firstfirst) + '&count=' + (filterData.last + 1) + filter); // Load data for export
            grid.attachEvent("onAfterLoad", function () {
                if (flag) {
                    var size = grid.getPager().config.size; // Get page size
                    var page = grid.getPage(); // Get current page
                    var first = size * page; // Calculate first index for export
                    var last = (first + size) - 1; // Calculate last index for export
                    if ($$("Export1").getValue() == '1') {
                        console.log("Entro");
                        for (var j = 0; j < grid.config.columns.length; j++) {
                            if (grid.config.columns[j].exportType) {
                                delete grid.config.columns[j].format; // Remove format for export
                            }
                        }
                        this.app.callEvent("export:data", [{
                            NameReport: _("Casino") + ($$("datatable").count() > 0 ? "" : _(" - No hay datos")) + " - " + new Date().toLocaleString(),
                            TypeReport: "Excel" // Set report type to Excel
                        }]);
                        webix.toExcel(grid, {
                            filter: function (obj) {
                                return grid.getIndexById(obj.id) >= first && grid.getIndexById(obj.id) <= last; // Filter data for export
                            },
                            filename: "Virtualsoft - " + new Date().toLocaleString("en-GB", {hour12: true}).replace(/^(\d{4})-(\d{2})-(\d{2})$/g, '$3/$2/$1').replace(/[\/:]/g, '_').toUpperCase() + " - " + ($$("datatable").count() > 0 ? "" : _("No hay datos - ")) + _("Casino"),
                            ignore: {"detailTittle": true, "Type": true}, // Columns to ignore in export
                            footer: false // Do not include footer in export
                        });
                    } else {
                        if ($$("Export1").getValue() == '2') {
                            this.app.callEvent("export:data", [{
                                NameReport: _("Casino") + ($$("datatable").count() > 0 ? "" : _(" - No hay datos")) + " - " + new Date().toLocaleString(),
                                TypeReport: "PDF" // Set report type to PDF
                            }]);
                            webix.toPDF(grid, {
                                filter: function (obj) {
                                    return grid.getIndexById(obj.id) >= first && grid.getIndexById(obj.id) <= last; // Filter data for export
                                },
                                filename: "Virtualsoft - " + new Date().toLocaleString("en-GB", {hour12: true}).replace(/^(\d{4})-(\d{2})-(\d{2})$/g, '$3/$2/$1').replace(/[\/:]/g, '_').toUpperCase() + " - " + ($$("datatable").count() > 0 ? "" : _("No hay datos - ")) + _("Casino"),
                                autowidth: true, // Auto width for PDF
                                ignore: {"detailTittle": true, "Type": true}, // Columns to ignore in export
                                footer: false // Do not include footer in export
                            });
                        }
                    }
                    flag = false; // Reset flag
                    $$("Export1").setValue(""); // Reset export selection
                }
            }.bind(this));
        });

        // Event handler for displaying user information in a popup
        this.on(this.app, "popupUserIframe", (id) => {
            webix.ui({
                view: "window",
                id: "popupUserIframe", // ID for the popup window
                head: {
                    view: "toolbar",
                    cols: [
                        {
                            view: "label",
                            label: _("Información"), // Label for the popup
                            align: "center"
                        },
                        {
                            view: "icon", icon: "wxi-close", click: function () {
                                this.getTopParentView().hide(); // Close the popup on click
                            }
                        }
                    ]
                },
                position: "center", // Center the popup
                modal: true, // Make the popup modal
                body: {
                    view: "iframe", id: "frame-body", src: "/#!/top/customers?user=" + id + "/information" // Iframe source for user information
                }
            }).show(); // Show the popup
            $$("popupUserIframe").setPosition(15, 15); // Set position of the popup
            $$("popupUserIframe").$setSize(($(window).width()) - 30, $(window).height() - 30); // Set size of the popup
        });

        // Event handler for country selection
        $$("Country").attachEvent("onItemClick", function (id, e) {
            webix.ajax().headers({
                "Content-type": "application/json"
            }).post(devConfig.geturlApi() + "Agent/GetAgentCountries", '', {
                error: function (text, data, XmlHttpRequest) {
                    webix.message("Error! "); // Show error message on failure
                },
                success: function (text, data, XmlHttpRequest) {
                    var data = JSON.parse((text.replace(/"Id"/g, '"id"').replace(/"Name"/g, '"value"'))); // Parse country data
                    var optionsCountries = $$("Country").getList(); // Get country list
                    optionsCountries.clearAll(); // Clear previous options
                    optionsCountries.parse(data.Data); // Parse new country data
                }
            });
        });
    }
}

// FILE DOCUMENTED
